import axios from "axios";

export const state = {
    reportcashiersales: [],
};

export const getters = {
    reportcashiersales: state => state.reportcashiersales,
};

export const mutations = {
    setReportCashierSale(reportcashiersales, newValue) { state.reportcashiersales = newValue},
};

export const actions = {
    fetchReportCashierSale({ commit }) {
        axios.get('/reportcashiersales').then(res => {
            commit('setReportCashierSale', res.data.sales)
        })
    },
    filterReportCashierSale({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportcashiersales";
        axios.post(url, formData).then((response) => {
            commit('setReportCashierSale', response.data.sales)
        })
    },
};
